import { string, object, number, array } from "yup"
import { ID2 } from "./yup.common"

export default object({
  id: ID2("Contract"),
  status: string().required("Please enter the contract status!"),
  startDate: string()
    .required("Please enter the start date of contract!")
    .label("Start Date"),
  endDate: string()
    .required("Please enter the end date of contract!")
    .label("End Date"),
  entityIssued: ID2("Vehicle").required(),
  contractTypeId: ID2("Contract Type").required("Contract Type is required!"),
  resourceAmount: number()
    .min(0, "The resource amount shoud me minimum zero")
    // .positve("Resource Amount should be positive")
    .label("Resource Amount"),
  dailyAllowance: number()
    .min(0, "The daily allowance shoud me minimum zero")
    // .positve("Daily Allowance should be positive")
    .label("Daily Allowance"),
  recurringExpenses: array(
    object({
      shiftId: ID2("Shift").required("Please enter a valid shift!"),
    })
  ),
})
